var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"b-popover",rawName:"v-b-popover.hover.top",value:(_vm.tooltip),expression:"tooltip",modifiers:{"hover":true,"top":true}}],ref:"card",staticClass:"card",attrs:{"title":_vm.title}},[_c('div',{staticClass:"card-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }